import React from "react";
import LoadingState from "./LoadingState";
import LoginForm from "./forms/LoginForm";
import SignupForm from "./forms/SignupForm";
import ForgotPasswordForm from "./forms/ForgotPasswordForm";
import { useAuthContext } from "./AuthContext";
import "../../styles/auth.css";

const AuthFormRouter = ({ showAppLoading }) => {
  const { currentView } = useAuthContext();

  if (showAppLoading) {
    return <LoadingState />;
  }

  return (
    <>
      {currentView === "login" && <LoginForm />}
      {currentView === "signup" && <SignupForm />}
      {currentView === "forgot-password" && <ForgotPasswordForm />}
    </>
  );
};

export default AuthFormRouter;
